import {updateAttributes} from '../utils/cart';

class DismissSection extends HTMLElement {
  constructor() {
    super();

    this.dismissId = this.dataset.dismissId;
    this.dismissTarget = document.querySelector(`#shopify-section-${this.dismissId}`);
    this.dismissButton = this.querySelector('button');

    this.dismissButton.addEventListener('click', this.dismissSection.bind(this));
  }

  dismissSection() {
    if (this.dismissTarget) {
      this.dismissTarget.remove();

      updateAttributes({
        [`Dismissed section - ${this.dismissId}`]: true
      })
    }
    else {
      console.warn(`Dismiss target with ID ${this.dismissId} not found.`);
    }
  }
}

try {
  customElements.define('dismiss-section', DismissSection);
}
catch(e) {}
